module.exports = __webpack_public_path__ + "img/slider_d06.6187751.1c4ffbd1.png";